import StoreSvg from '@assets/images/svg/store.svg';
import React from 'react';
import { View } from 'react-native';

export interface StoreIconProps {
    size?: number;
    color?: string;
}

export function StoreIcon({ size = 24, color = '#4D4D4D' }: StoreIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <StoreSvg width={size} height={size} color={color} />
        </View>
    );
}

export default StoreIcon;
